<template>
  <div class="form-grey-box">
    <span
      @click.prevent="$emit('unselect')"
      v-if="showUnselectButton"
      class="close-button"
    >
      <v-icon>close</v-icon>
    </span>

    <v-text-field
      class="grey-box-input mb-3"
      :label="infoLabel"
      v-model="info.nome"
      readonly
      placeholder=" "
    ></v-text-field>

    <hr v-if="showAddress" />

    <div class="justify-space-between">
      <v-text-field
        v-if="showAddress"
        class="grey-box-input input_label"
        label="Endereço"
        readonly
        v-model="infoFullAddress"
        placeholder=" "
      ></v-text-field>

      <p class="link-edit" v-if="showAddressChangeButton && this.info.tipo_pessoa == 'FISICA'">
        <a href="javascript:void(0)" @click="editarEndereco()" id="editar_endereco" 
          >Editar endereço</a
        >
      </p>
    </div>

    <!-- Modal editar endereço -->
    <v-dialog
      v-model="showModal"
      v-if="!!infoFullAddress"
      :max-width="'640'"
      persistent
    >
      <base-modal>
        <h2 class="headline">Endereço</h2>

        <endereco-component
          v-if="endereco"
          :endereco="endereco"
          :lograduroCompacto="lograduroCompacto"
          :numberRequired="info.tipo_pessoa !== 'FISICA'"
          class="mt-3"
          ref="formEnderecoComponent"
        ></endereco-component>

        <v-layout row wrap>
          <v-flex xs6>
            <button
              class="jns-button ml-0 white-button"
              @click="showModal = false"
            >
              Cancelar
            </button>
          </v-flex>

          <v-flex xs6>
            <button
              class="button jns-button yellow-button ml-0"
              @click="salvarEndereco()"
            >
              Salvar
            </button>
          </v-flex>
        </v-layout>
      </base-modal>
    </v-dialog>
  </div>
</template>

<script lang="js">
export default {
  name: "PropostaForm",
  props: {
    info:{type:Object, default:()=>{}},
    showUnselectButton:{type:Boolean, default:false},
    showAddressChangeButton:{type:Boolean, default:false},
    lograduroCompacto: { type: Boolean, default: true }
    },
  data(){
    return {
      infoReadonly: true,
      showModal: false,
      endereco:{}
    }
  },
  computed: {
    infoFullAddress() {
      let t = this;
      if (!t.info) return false;
      if (!this.info.endereco) return "Não Informado";

      let logradouroArray = t.info.endereco.logradouro.split(',');

      if(!!((t.info||{}).endereco||{}).complemento)
      logradouroArray = logradouroArray[0].split(` - ${t.info.endereco.complemento}`)

      if((logradouroArray || []).length > 0){
        t.info.endereco.logradouro = logradouroArray[0];

        this.endereco = {...this.info.endereco};
      };

      let address = t.info.endereco;

      let addressValidInfo = [
        address.logradouro,
        address.numero ? address.numero : '',
        address.complemento ? address.complemento : '',
        /*address.number, */ address.bairro,
        address.cep,
      ].filter((item) => item);

      let fullAddress =
        addressValidInfo.join(", ") +
        " - " +
        [address.cidade, address.uf].filter((item) => item).join(" - ");
      if (fullAddress == " - ") return "Não Informado";
      return fullAddress;
    },

    infoLabel() {
      if (this.info.tipo_pessoa == "JURIDICA") return "Razão Social";
      else return "Nome";
    },
    showAddress() {
      if (this.info) {
        if (
          this.info.nome != "" &&
          this.info.nome != null &&
          this.info.endereco
        )
          return true;
        else return false;
      } else return false;
    },
  },
  methods:{
    salvarEndereco(){
      if(this.$refs.formEnderecoComponent.$refs.formEndereco.validate()){
        this.showModal=false;
        this.$emit('salvarEndereco', {...this.endereco, numero: this.endereco.numero || 'SN'});
      }
    },

    editarEndereco() {
      this.endereco = {...this.info.endereco};
      this.showModal = true;
     }
  },
  watch:{
    showModal(value) {
      if(!value)
        this.endereco = null;
    }
  }
};
</script>

<style lang="scss" scoped>
#jns {
  .theme--light.v-input {
    font-size: 13px;
  }
}
.close-button {
  position: absolute;
  cursor: pointer;
  top: 20px;
  right: 20px;
}

.justify-space-between {
  display: flex;
  justify-content: space-between;
}

.link-edit {
  justify-content: end;
  display: flex;
  align-items: flex-end;
}

.form-grey-box {
  margin: 10px 0;
  padding: 25px;
  padding-bottom: 0px;
  width: 100%;
  position: relative;
  border: 1px solid #dfdfdf;
  border-radius: 4px;
  background-color: #f7f7f7;
  font-weight: bold;
  position: relative;
  hr {
    border: 1px solid rgba(0, 0, 0, 0.08);
    position: absolute;
    width: 100%;
    left: 0;
    top: calc(50% - 2px);
  }
}
</style>



// WEBPACK FOOTER //
// ./src/components/PersonInfoBox.vue